import * as actionType from '../actions/actionTypes';
import updateObject from '../Utility';

const initState = {
    contacts: null,
    results: 0,
    loadingContacts: false,
    errorContacts: null,
    selectedContact: null,
    totalCountOfContact: 0
}

const fetchContactsStart = (state, action) => {
    return updateObject(state, { errorContacts: null, loadingContacts: true });
}

const fetchContactsSuccess = (state, action) => {
    const contactsData = action.contacts
    const totalCountOfContact = contactsData.data.docCountBeforePagination
    return updateObject(state, { errorContacts: null, loadingContacts: false, results: contactsData.results, contacts: contactsData.data.data, totalCountOfContact });
}

const fetchContactsFail = (state, action) => {
    return updateObject(state, {
        errorContacts: action.errorContacts,
        loadingContacts: false
    });
}

const selectContactSuccess = (state, action) => {
    const contactsCopy = JSON.parse(JSON.stringify(state.contacts))
    const selectedContact = contactsCopy.find(contact => contact._id === action.contactId)
    return updateObject(state, {
        selectedContact
    });
}

const insertContact = (state, action) => {
    const contactsCopy = JSON.parse(JSON.stringify(state.contacts))
    const totalCountOfContact = state.totalCountOfContact + 1
    const results = state.results + 1
    contactsCopy.unshift(action.contact)

    return updateObject(state, {
        contacts: contactsCopy,
        totalCountOfContact,
        results
    });
}

const updateContact = (state, action) => {
    const contactsCopy = JSON.parse(JSON.stringify(state.contacts))
    let selectedContact = state.selectedContact && JSON.parse(JSON.stringify(state.selectedContact))
    const contactIndex = contactsCopy.findIndex(contact => contact._id === action.contact._id)
    if (contactIndex > -1) {
        contactsCopy.splice(contactIndex, 1, action.contact)
        if (selectedContact?._id === action.contact._id) selectedContact = action.contact
        return updateObject(state, {
            contacts: contactsCopy,
            selectedContact
        });
    }
    return updateObject(state, {})
}

const deleteContact = (state, action) => {
    const contactsCopy = JSON.parse(JSON.stringify(state.contacts))
    let selectedContact = state.selectedContact && JSON.parse(JSON.stringify(state.selectedContact))
    const contactIndex = contactsCopy.findIndex(contact => contact._id === action.contact._id)
    if (contactIndex > -1) {
        contactsCopy.splice(contactIndex, 1)
        if (selectedContact?._id === action.contact._id) selectedContact = undefined
        return updateObject(state, {
            contacts: contactsCopy,
            selectedContact
        });
    }
    return updateObject(state, {})
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actionType.FETCH_CONTACTS_START: return fetchContactsStart(state, action);
        case actionType.FETCH_CONTACTS_SUCCESS: return fetchContactsSuccess(state, action);
        case actionType.FETCH_CONTACTS_FAIL: return fetchContactsFail(state, action);
        case actionType.SELECT_CONTACT_SUCCESS: return selectContactSuccess(state, action);
        case actionType.INSERT_NEW_CONTACT: return insertContact(state, action);
        case actionType.UPDATE_CONTACT: return updateContact(state, action);
        case actionType.DELETE_CONTACT: return deleteContact(state, action);
        //SELECT_CONTACT_SUCCESS
        default:
            return state
    }
}

export default reducer
